import { Injectable } from '@angular/core';

@Injectable()
export class SliderImagesDataService
{
    public sliderImages: any[] = [];
    constructor() {

    }

    public addImage(imageURL)
    {
        if(imageURL.response.mediaType == 1 || imageURL.response.mediaType == 2)
        {
            this.sliderImages.push(imageURL)
        }
        
    }

    public deleteImage(element)
    {
        let elementToDelete=this.sliderImages.findIndex(x => x.item.name==element.name);
        if (elementToDelete > -1 && elementToDelete < this.sliderImages.length) {
            this.sliderImages.splice(elementToDelete, 1);
          }
    }

    public getImages(): any[]
    {
        return this.sliderImages;
    }


}
